import { Component } from '@angular/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
@Component({
  selector: 'app-empty',
  imports: [NzEmptyModule],
  templateUrl: './empty.component.html',
  styleUrl: './empty.component.less',
})
export class EmptyComponent {
contentTpl: null|string|undefined='无效链接'
}
